export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SlideTray.vue?vue&type=template&id=eae1202e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/slide-tray-workflow/SlideTray.vue?vue&type=template&id=eae1202e&scoped=true&
// module id = 332
// module chunks = 0